import * as Scrivito from "scrivito"

export const AttributeInformationObjClass = Scrivito.provideObjClass(
  "AttributeInformation",
  {
    attributes: {
      title: "string",
      description: "string",
      image: ["reference", { only: "Image" }],
      imageWidgets: ["widgetlist", { only: "ImageWidget" }]
    }
  }
)

export type AttributeInformationObj = InstanceType<
  typeof AttributeInformationObjClass
>
